import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {
    ICounterparties,
    ICounterpartiesListItem,
    CounterpartiesResponseType
} from "@/entity/finance/counterparties/counterparties.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {CounterpartiesGeneralRequestType} from "@/form/finance/counterparties/CounterpartiesGeneral.types";
import {ResponseDataType} from "@/form/form.types";
import {createLogger} from "vuex";
import {prepareFormData} from '@/store/utils/formDataHelper';
import {checkUserRole, getUserData} from '@/router/Lib/helper';

@Module({
    namespaced: true,
    name: 'counterparties',
    store,
    dynamic: true,
})
class CounterpartiesModule extends VuexModule {
    counterparties: ICounterparties | null = null;
    counterparty: ICounterpartiesListItem | null = null;
    counterpartiesLoaded = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ counterparties: ICounterparties; counterpartiesLoaded: boolean }> {

        let counterpartiesLoaded = false;
        const counterparties = await store.$repository.counterparties.fetchAll(prepareFormData(data));
        if (counterparties) {
            counterpartiesLoaded = true;
        }
        return {counterparties, counterpartiesLoaded};
    }

    @Action({rawError: true})
    async import(data: File): Promise<ResponseDataType> {
        const formData = new FormData();
        if (checkUserRole() == 'owner') {
            const userData = getUserData();
            formData.append('salon_id', userData.studios.toString());
        } else if (store.state.salon_id) {
            formData.append('salon_id', store.state.salon_id.toString());
        }
        formData.append('import_file', data);
        const resp = await store.$repository.counterparties.import(formData);
        return resp;
    }

    @Action({rawError: true})
    async export(): Promise<ResponseDataType> {
        const formData = new FormData();
        if (checkUserRole() == 'owner') {
            const userData = getUserData();
            formData.append('salon_id', userData.studios.toString());
        } else if (store.state.salon_id) {
            formData.append('salon_id', store.state.salon_id.toString());
        }
        const resp = await store.$repository.counterparties.export();
        return resp;
    }

    @Action({rawError: true})
    async create(data: CounterpartiesGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.create(data);
        return resp;
    }

    @Action({rawError: true})
    async update(data: CounterpartiesGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.update(data);
        return resp;
    }

    /*@MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: ICounterpartiesListItem  ; counterpartiesLoaded: boolean }> {
        let counterpartiesLoaded = false;
        const salon = await store.$repository.counterparties.fetchData(data);
        if (salon) {
            counterpartiesLoaded = true;
        }
        return { salon, counterpartiesLoaded};
    }
    @Action({rawError: true})
    async create(data: CounterpartiesGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: CounterpartiesGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.delete(data);
        return resp;
    }*/
}

export const CounterpartiesStore = getModule(CounterpartiesModule);
